export class InstallationParams {
  IdBrand: number = 0;
  Region: string[] = [];
  Sector: string[] = [];
  VnPlate: string[] = [];
  PvGroup: string[] = [];
  SectionPv: string[] = [];
  Installation: string[] = [];
}
